module.exports = __webpack_public_path__ + "static/favicon.0af11031.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.ico
// module id = 49
// module chunks = 35783957827783 56635243537030 95732811918152